import { createVanIconComponent } from "./van"

const BulbOutlined = createVanIconComponent("bulb-o")
export default BulbOutlined
